var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { utilTime } from "../../utils/utilTime";
import { TypeActionReconnectAfterLogin, } from "../reconnect-after-login/actionReconnectAfterLogin";
import { TypeActionLimitedActionInfo } from "./actionLimitedActionInfo";
var initial = {
    createdAt: utilTime.timestamp(),
    limitedAction: [],
};
export var reducerLimitedActionInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionLimitedActionInfo.Received && action.limitedAction) {
        return __assign({}, state, { createdAt: utilTime.timestamp(), limitedAction: action.limitedAction });
    }
    else if (action.type === TypeActionReconnectAfterLogin.DisconnectedByLogin) {
        return initial;
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/limited-action-info/reducerLimitedActionInfo.ts
// module id = 2544
// module chunks = 3